import $ from "jquery";

$(document).ready(function () {
    $(".log-btn").click(function () {
        // $(".log-status").addClass("wrong-entry");
        $(".alert").fadeIn(500);
        setTimeout($(".alert").fadeOut(2500), 3000);
    });
    $(".form-control").keypress(function () {
        $(".log-status").removeClass("wrong-entry");
    });
});



// WEBPACK FOOTER //
// ./src/components/login/index.js